export const getActiveToasts = (state) => state.active_toasts
export const getToastTypes = (state) => state.toast_types

export const getLoadingToast = (state) => state.loading_toast.toast
export const getLoadingMessage = (state) => state.loading_toast.message
export const getIsLoading = (state) => state.loading_toast.active

export const getOriginalPlugin = (state) => state.original_plugin
